module.exports = __webpack_public_path__ + "static/media/ic_btn_play_big.ccb8ce31.svg";